var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from '../core/model';
var seriesHighlight = /** @class */ (function (_super) {
    __extends(seriesHighlight, _super);
    function seriesHighlight() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'series-highlight';
        return _this;
    }
    seriesHighlight.prototype.getEvents = function () {
        return {
            'series:mouseenter': this.onSeriesMouseEnter,
            'series:mouseleave': this.onSeriesMouseLeave,
            'legendItem:mouseenter': this.onLegendItemMouseEnter,
            'legendItem:mouseleave': this.onLegendItemMouseLeave,
        };
    };
    seriesHighlight.prototype.onSeriesMouseEnter = function (event) {
        this._toggleBlurSeries(event.seriesIndex, true);
    };
    seriesHighlight.prototype.onSeriesMouseLeave = function (event) {
        this._toggleBlurSeries(event.seriesIndex, false);
    };
    seriesHighlight.prototype.onLegendItemMouseEnter = function (event) {
        var _a = event.legendItem, legendType = _a.legendType, seriesIndex = _a.seriesIndex, visible = _a.visible;
        legendType === 'series' && visible && this._toggleBlurSeries(seriesIndex, true);
    };
    seriesHighlight.prototype.onLegendItemMouseLeave = function (event) {
        var _a = event.legendItem, legendType = _a.legendType, seriesIndex = _a.seriesIndex, visible = _a.visible;
        legendType === 'series' && visible && this._toggleBlurSeries(seriesIndex, false);
    };
    seriesHighlight.prototype._toggleBlurSeries = function (seriesIndex, blur) {
        var _this = this;
        this.chart.eachSeriesModel(function (seriesModel, index) {
            if (index !== seriesIndex) {
                _this.chart.getSeriesModel(index).toggleBlurSeries(blur);
            }
        });
    };
    return seriesHighlight;
}(Model));
export default seriesHighlight;
